/* eslint-disable */
export const menus = [
  {
    action: 'zmdi-view-dashboard',
    title: 'Inicio',
    path: '/dashboard',
    active: true,
    label: 'Old',
    items: null
  },
  {
    key: 'inbox',
    action: 'zmdi-inbox',
    title: 'Turnos sin confirmar',
    path: '/inbox',
    active: false,
    label: 'Old',
    puedoModulo: ['inbox:lectura'],
    items: null
  },
  {
    key: 'pacientes',
    action: 'zmdi-hospital',
    title: 'Pacientes',
    path: '/pacientes',
    active: false,
    label: 'Old',
    puedoModulo: ['pacientes'],
    items: [
      { title: 'Datos generales', path: '/pacientes/busqueda' },
      //{ title: 'Carga masiva', path: '/pacientes/carga-masiva' }
      ]
  },
  {
    key: 'turnosdia',
    action: 'zmdi-calendar',
    title: 'Agenda',
    path: '/agenda',
    active: false,
    label: 'Old',
    puedoModulo: ['agenda:lectura'],
    items: null
  },
  {
    key: 'reportes',
    action: 'zmdi-chart',
    title: 'Reportes',
    path: '/reportes',
    active: false,
    label: 'Old',
    puedoModulo: ['reportes:lectura'],
    items: null
  },
  /*{
    key: 'tesoreria',
    action: 'zmdi-money',
    title: 'Tesorería',
    path: 'tesoreria',
    active: false,
    label: 'Old',
    puedoModulo: ['tesoreria'],
    items: [
      { title: 'Facturación Asociación', path: '/tesoreria/facturacion-asociacion', puedo: ['tesoreria_comprobantes-asociacion:lectura'] },
      { title: 'Facturación Centro', path: '/tesoreria/facturacion-centro', puedo: ['tesoreria_comprobantes-centro:lectura'] },
      { title: 'Recibos', path: '/tesoreria/recibos', puedo: ['tesoreria_recibos:lectura'] },
      { title: 'Proyectos de pago', path: '/tesoreria/proyectos-pago', puedo: ['tesoreria_proyectos-pago:lectura'] },
      { title: 'Ordenes de pago', path: '/tesoreria/ordenes-pago', puedo: ['tesoreria_ordenes-pago:lectura'] },
      { title: 'Interfaces', path: '/tesoreria/interfaces', puedo: ['tesoreria_interfaces:lectura'] },
      { title: 'Certificados de retención', path: '/tesoreria/retenciones', puedo: ['tesoreria_retenciones:lectura'] },
    ]
  },
   {
    action: 'zmdi-file',
    title: 'Informes',
    path: 'informes',
    active: false,
    label: 'Old',
    items: null
  }, */
  {
    key: 'administracion',
    action: 'zmdi-laptop',
    title: 'Administración',
    active: false,
    label: 'Old',
    puedoModulo: ['admin'],
    items: [
      { title: 'Usuarios', path: '/administracion/usuarios', puedo: ['admin_usuarios:lectura'] },
      { title: 'Roles', path: '/administracion/roles', puedo: ['admin_roles:lectura'] },
      { title: 'Permisos', path: '/administracion/permisos', puedo: ['admin_permisos:lectura'] },
      {
        title: 'T. Entidades',
        path: '/administracion/tipo-entidades',
        puedo: ['admin_tipo-entidades:lectura']
      },
      {
        title: 'Instituciones',
        path: '/administracion/instituciones',
        puedo: ['admin_instituciones:lectura']
      },
      {
        title: 'Obras Sociales',
        path: '/administracion/obras-sociales',
        puedo: ['admin_obras-sociales:lectura']
      },
      {
        title: 'Practicas',
        path: '/administracion/practicas',
        puedo: ['admin_practicas:lectura']
      },
      {
        title: 'Días no Laborables',
        path: '/administracion/dias-no-laborables',
        puedo: ['admin_dias-no-laborables:lectura']
      },
      { title: 'Notificaciones', path: '/administracion/notificaciones', puedo: ['admin_notificaciones:lectura'] },
    ]
  }
]
